import { useEffect, useState } from "react";
import { adapter } from "@/services/db";

// Realtime subscription to a single Firestore document.
export function useDoc(collectionName, id) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsub = adapter.subscribeDoc(collectionName, id, (d) => { setData(d); setLoading(false); });
    return () => unsub && unsub();
  }, [collectionName, id]);
  return { data, loading };
}
